import(/* webpackMode: "eager" */ "/root/LeadCRM/app/not-found.tsx");
